<div class="promo-page">
    <!-- =========================================
       ENCABEZADO
  ========================================== -->
    <section class="promo-header">
        <div class="promo-header-content">
            <span class="promo-eyebrow">
                PROMOCIÓN
            </span>
            <h1 class="promo-title">
                {{ promo }}
            </h1>
            <p class="promo-subtitle" *ngIf="stepOne">
                Elige el producto que prefieres para tu promoción.
            </p>
            <p class="promo-subtitle" *ngIf="stepTwo">
                Selecciona la cantidad de productos que deseas llevar.
            </p>
        </div>
    </section>
    <!-- =========================================
       PASO 1
       SELECCIONAR PRODUCTO
  ========================================== -->
    <section class="promo-step" *ngIf="stepOne">
        <div class="promo-step-header">
            <div>
                <span class="step-label">
                    PASO 1 DE 2
                </span>
                <h2>
                    Elige tu producto
                </h2>
                <p>
                    Selecciona una de las opciones disponibles para continuar.
                </p>
            </div>
        </div>
        <div class="promo-options" *ngIf="promos.length > 0">
            <article class="promo-option" *ngFor="let item of promos" [class.promo-option-selected]="item.selected"
                (click)="selectedPromo(item)">
                <div class="promo-option-image">
                    <img [src]="item.urlFoto" [defaultImage]="defImgProd"
                        [alt]="item.productoAgrupador || item.descripcionPromo">
                </div>
                <div class="promo-option-content">
                    <div class="promo-option-info">
                        <h3>
                            {{ item.descripcionPromo }}
                        </h3>
                    </div>
                    <div class="promo-check" *ngIf="item.selected">
                        <mat-icon>
                            check
                        </mat-icon>
                    </div>
                </div>
            </article>
        </div>
        <!-- ACCIÓN -->
        <div class="promo-action">
            <button class="promo-primary-button" mat-raised-button type="button" (click)="continuar()"
                [disabled]="dataPromo === null">
                CONTINUAR
            </button>
        </div>
    </section>
    <!-- =========================================
       PASO 2
       SELECCIONAR CANTIDADES
  ========================================== -->
    <section class="promo-step" *ngIf="stepTwo">
        <div class="promo-step-header">
            <div>
                <span class="step-label">
                    PASO 2 DE 2
                </span>
                <h2>
                    Selecciona tus productos
                </h2>
                <p>
                    Elige la cantidad de cada producto hasta completar tu promoción.
                </p>
            </div>
            <div class="promo-progress">
                <span>
                    Cantidad seleccionada
                </span>
                <strong>
                    {{ selectedProductsCart.length > 0 ? selectedProductsCart.length : 0 }}
                </strong>
            </div>
        </div>
        <div class="promo-products" *ngIf="products.length > 0">
            <article class="promo-product" *ngFor="let product of products">
                <!-- IMAGEN -->
                <div class="promo-product-image">
                    <img [src]="product.urlFotoAgrupador || product.urlFoto" [defaultImage]="defImgProd"
                        [alt]="product.producto">
                </div>
                <!-- INFORMACIÓN -->
                <div class="promo-product-info">
                    <h3>
                        {{ product.producto }}
                    </h3>
                    <p class="promo-product-description" *ngIf="product?.productoAgrupador">
                        {{ product?.descripcionProducto }}
                    </p>
                </div>
                <!-- CANTIDAD -->
                <div class="promo-product-quantity">
                    <span>
                        Cantidad
                    </span>
                    <div class="quantity-control">
                        <button type="button" class="quantity-button" aria-label="Disminuir cantidad"
                            (click)="changeQty('restar', product)">
                            <mat-icon>
                                remove
                            </mat-icon>
                        </button>
                        <div class="quantity-value">
                            {{ product.qty ? product.qty : 0 }}
                        </div>
                        <button type="button" class="quantity-button" aria-label="Aumentar cantidad"
                            (click)="changeQty('sumar', product)">
                            <mat-icon>
                                add
                            </mat-icon>
                        </button>
                    </div>
                </div>
            </article>
        </div>
        <!-- RESUMEN -->
        <div class="promo-selection-summary">
            <div class="promo-summary-text">
                <span>
                    Productos seleccionados
                </span>
                <strong>
                    {{ selectedProductsCart.length }}
                </strong>
            </div>
            <div class="promo-summary-message" [class.promo-summary-complete]="qtyComplete">
                <mat-icon>
                    {{ qtyComplete ? 'check_circle' : 'info' }}
                </mat-icon>
                <span *ngIf="!qtyComplete">
                    Completa la cantidad de productos para continuar.
                </span>
                <span *ngIf="qtyComplete">
                    ¡Listo! Ya puedes seleccionar tu promoción.
                </span>
            </div>
        </div>
        <!-- ACCIÓN -->
        <div class="promo-action">
            <button class="promo-primary-button" mat-raised-button type="button" (click)="proceder()"
                [disabled]="!qtyComplete">
                SELECCIONAR
            </button>
        </div>
    </section>
</div>